import * as React from 'react';

import classnames from 'classnames';

import {Stack} from 'shells/layout/stack/stack';

import styles from './ai-generating-state.module.css';

export function AiGeneratingState() {
    return (
        <div className={styles.container}>
            <Stack justifyContent='space-between' alignItems='center' isFullHeight={true}>
                <div className={classnames(styles['shimmer-rectangle'], styles['shimmer-large'])} />

                <div
                    className={classnames(styles['shimmer-rectangle'], styles['shimmer-medium'])}
                />

                <div className={classnames(styles['shimmer-rectangle'], styles['shimmer-small'])} />
                <div className={classnames(styles['shimmer-rectangle'], styles['shimmer-small'])} />
                <div className={classnames(styles['shimmer-rectangle'], styles['shimmer-small'])} />
                <div className={classnames(styles['shimmer-rectangle'], styles['shimmer-small'])} />
                <div className={classnames(styles['shimmer-rectangle'], styles['shimmer-small'])} />
                <div className={classnames(styles['shimmer-rectangle'], styles['shimmer-small'])} />

                <div
                    className={classnames(
                        styles['shimmer-rectangle'],
                        styles['shimmer-small-centered']
                    )}
                />

                <div className={classnames(styles['shimmer-rectangle'], styles['shimmer-large'])} />
            </Stack>
        </div>
    );
}
